"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const utils_js_1 = require("./utils.js");
const SubRowExpander_js_1 = require("./SubRowExpander.js");
const index_js_1 = require("./columns/index.js");
const index_js_2 = require("./cells/index.js");
const TableCell = (props) => {
    const { cell, cellIndex, isDisabled, tableHasSubRows, tableInstance, expanderCell, density, } = props;
    const hasSubRowExpander = cellIndex ===
        cell.row.cells.findIndex((c) => c.column.id !== index_js_1.SELECTION_CELL_ID);
    const getSubRowStyle = () => {
        if (!tableHasSubRows || !hasSubRowExpander) {
            return undefined;
        }
        // If it doesn't have sub-rows then shift by another level to align with expandable rows on the same depth
        const dynamicMargin = cell.row.depth + (cell.row.canExpand ? 0 : 1);
        let cellPadding = 16;
        let expanderMargin = 8;
        if (density === 'condensed') {
            cellPadding = 12;
            expanderMargin = 4;
        }
        else if (density === 'extra-condensed') {
            cellPadding = 8;
            expanderMargin = 4;
        }
        const multiplier = 26 + expanderMargin; // 26 = expander width
        return {
            paddingLeft: cellPadding + dynamicMargin * multiplier,
        };
    };
    const cellElementProps = cell.getCellProps({
        className: (0, classnames_1.default)('iui-table-cell', cell.column.cellClassName, {
            'iui-table-cell-sticky': !!cell.column.sticky,
        }),
        style: {
            ...(0, utils_js_1.getCellStyle)(cell.column, !!tableInstance.state.isTableResizing),
            ...getSubRowStyle(),
            ...(0, utils_js_1.getStickyStyle)(cell.column, tableInstance.visibleColumns),
        },
    });
    const cellProps = {
        ...tableInstance,
        ...{ cell, row: cell.row, value: cell.value, column: cell.column },
    };
    const cellContent = (React.createElement(React.Fragment, null,
        tableHasSubRows && hasSubRowExpander && cell.row.canExpand && (React.createElement(SubRowExpander_js_1.SubRowExpander, { cell: cell, isDisabled: isDisabled, cellProps: cellProps, expanderCell: expanderCell, density: density })),
        cell.render('Cell')));
    const cellRendererProps = {
        cellElementProps,
        cellProps,
        children: (React.createElement(React.Fragment, null,
            cellContent,
            cell.column.sticky === 'left' &&
                tableInstance.state.sticky.isScrolledToRight && (React.createElement("div", { className: 'iui-table-cell-shadow-right' })),
            cell.column.sticky === 'right' &&
                tableInstance.state.sticky.isScrolledToLeft && (React.createElement("div", { className: 'iui-table-cell-shadow-left' })))),
    };
    return (React.createElement(React.Fragment, null, cell.column.cellRenderer ? (cell.column.cellRenderer({
        ...cellRendererProps,
        isDisabled: () => isDisabled,
    })) : (React.createElement(index_js_2.DefaultCell, { ...cellRendererProps, isDisabled: () => isDisabled }))));
};
exports.TableCell = TableCell;
exports.default = exports.TableCell;
